// Textos del listado de usuarios de marketing (marketing-users). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    MARKETING_USERS: {
      ACTIONS: {
        EXPORT_CSV: 'Exporta CSV',
        SOON: 'Aviat',
        RELOAD: 'Recarrega',
        LOADING: 'Carregant...',
        RETRY: 'Torna-ho a provar',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        FIRST_PAGE: 'Primera pàgina',
        LAST_PAGE: 'Última pàgina',
        DONE: 'Fet',
        CLOSE: 'Tanca',
        CLEAR: 'Neteja',
        APPLY: 'Aplica',
        CLEAR_ALL: 'Esborra-ho tot',
        REMOVE_FILTER: 'Treu {{label}}',
        CLEAR_SEARCH: 'Esborra la cerca',
      },
      FUNNEL: {
        ARIA: "Embut d'usuaris",
        FILTERED_BY: 'Dades filtrades per:',
        LOADING_SUMMARY: 'Carregant el resum',
        REGISTERED: 'Registrats',
        VERIFIED: 'Verificats',
        WITH_ROUTINE: 'Amb rutina de pooling',
        WITH_FINISHED_ROUTES: 'Amb rutes finalitzades',
        CONV_TOOLTIP: 'Sobre el total de registrats',
        CAE_NOTE: 'amb CAE actiu · {{pct}}% del total',
        PERMISSIONS_TITLE: 'Permisos concedits (de {{total}} registrats)',
      },
      PERMISSIONS: {
        NOTIFICATION: 'Notificacions',
        LOCATION: 'Ubicació',
        BACKGROUND_LOCATION: 'Ubicació en segon pla',
        PHYSICAL_ACTIVITY: 'Activitat física',
        BLUETOOTH: 'Bluetooth',
      },
      VIEWS: {
        ARIA: 'Vista',
        ALL: 'Tots',
        VERIFIED: 'Verificats',
        CAE: 'CAE actiu',
        ROUTINE: 'Amb rutina de pooling',
      },
      PANEL: {
        DEFAULT_TITLE: 'Usuaris',
        ALL_TITLE: 'Tots els usuaris',
        ALL_SUBTITLE: 'Cerca, filtra i tria quines columnes vols veure. Fes clic en un nom per obrir-ne la fitxa.',
        VERIFIED_TITLE: 'Usuaris verificats',
        VERIFIED_SUBTITLE: 'Usuaris que han completat la verificació.',
        CAE_TITLE: 'Usuaris amb CAE actiu',
        CAE_SUBTITLE: 'Usuaris amb el CAE activat.',
        ROUTINE_TITLE: 'Usuaris amb rutina de pooling',
        ROUTINE_SUBTITLE: 'Usuaris que tenen almenys una rutina de pooling.',
      },
      SEARCH: {
        PLACEHOLDER: 'Cerca per nom, cognoms, correu electrònic o telèfon',
        ARIA: 'Cerca usuaris',
      },
      FILTERS: {
        TITLE: 'Filtres avançats',
        VERIFIED: 'Verificat',
        CAE_ACTIVE: 'CAE actiu',
        WITH_ROUTINE: 'Amb rutina de pooling',
        MIN_FINISHED: 'Mín. rutes finalitzades',
        MIN_FINISHED_PLACEHOLDER: 'P. ex. 5',
        ROUTE_STATUS: 'Estat de la ruta de pooling',
        DATE_FROM: "Data d'alta des de",
        DATE_TO: "Data d'alta fins a",
        DATE_ERROR: 'Revisa les dates: han de ser vàlides i «Fins a» ha de ser igual o posterior a «Des de».',
        ALL: 'Tots',
        YES: 'Sí',
        NO: 'No',
        ROUTE_VERIFIED: 'Verificada',
        ROUTE_REJECTED: 'Rebutjada',
      },
      CHIPS: {
        VERIFIED: 'Verificat: {{value}}',
        CAE_ACTIVE: 'CAE actiu: {{value}}',
        WITH_ROUTINE: 'Amb rutina: {{value}}',
        MIN_FINISHED: 'Mín. rutes finalitzades: {{value}}',
        ROUTE_STATUS: 'Estat de la ruta: {{value}}',
        DATE_FROM: 'Alta des de: {{value}}',
        DATE_TO: 'Alta fins a: {{value}}',
      },
      COLUMNS: {
        EDIT: 'Edita les columnes',
        NAME: 'Nom',
        EMAIL: 'Correu electrònic',
        PHONE: 'Telèfon',
        VERIFIED: 'Verificat',
        CAE_ACTIVE: 'CAE actiu',
        FRAUD: 'Frau',
        COMPANY: 'Empresa',
        CREATED_AT: "Data d'alta",
        LAST_ACTIVITY: 'Última activitat',
        GENDER: 'Gènere',
        BIRTH_DATE: 'Data de naixement',
        STRIPE: 'Stripe',
        ACTIVE_VEHICLE: 'Vehicle actiu',
        ADDRESS_HOME: 'Adreça (casa)',
        ADDRESS_WORK: 'Adreça (feina)',
        DRIVING_LICENSE: 'Carnet de conduir',
        WELCOME_WHATSAPP: 'WhatsApp de benvinguda',
      },
      TABLE: {
        LOADING_ARIA: 'Carregant usuaris de màrqueting',
        EMPTY: "No s'han trobat usuaris amb els filtres aplicats.",
        LOAD_ERROR: "No s'ha pogut carregar el llistat d'usuaris de màrqueting.",
        VERIFIED: 'Verificat',
        NOT_VERIFIED: 'Sense verificar',
        YES: 'Sí',
        NO: 'No',
        GENDER_H: 'Home',
        GENDER_M: 'Dona',
        GENDER_O: 'Altre',
        ROWS_PER_PAGE: 'Files per pàgina',
        ROWS_OPTION: '{{n}} files',
        SHOWING_ONE: 'Mostrant {{shown}} de {{total}} usuari',
        SHOWING_OTHER: 'Mostrant {{shown}} de {{total}} usuaris',
      },
    },
  },
};
